import { SC_COMMUNICATION_TEMPLATE_URL } from '@/common/constants/external-urls';
import SurveySubmittedImg from '@/images/security-profile/onboarding-success.png';
import { AppButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ConfirmationBox = styled.div`
  background-color: var(--beige-main);
  border-radius: var(--semi-medium-border-radius);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--big-padding);
  width: 100%;
  gap: 32px;
  flex: 1;
`;

const ConfirmationImage = styled.img`
  height: 278px;
  width: 278px;
  object-fit: contain;
`;

const ScheduledPill = styled.span`
  background-color: rgba(125, 116, 224, 0.1);
  color: var(--security-culture-darker, #6058c2);
  border-radius: var(--grand-border-radius);
  padding: var(--xxxsmall-padding) var(--xsmall-padding);
  font-size: var(--xsmall-font-size);
`;

const ConfirmationContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  text-align: center;
`;

const ConfirmationTitle = styled.h2`
  font-size: var(--heading-medium-font-size);
  font-weight: 700;
  color: var(--black-main);
  margin: 0;
`;

const ConfirmationDescription = styled.p`
  font-size: var(--medium-font-size);
  line-height: 1.4;
  color: var(--black-main);
  margin: 0;
`;

interface SurveySentConfirmationProps {
  scheduledDate: Date;
  onGoToDashboard: () => void;
}

export const SurveySentConfirmation: React.FC<SurveySentConfirmationProps> = ({
  scheduledDate,
  onGoToDashboard,
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmationBox>
      <ConfirmationImage src={SurveySubmittedImg} alt="" />
      <ScheduledPill>
        {t('security.culture.send.survey.scheduled.date', {
          date: moment(scheduledDate).format('MMM D, YYYY'),
        })}
      </ScheduledPill>
      <ConfirmationContent>
        <ConfirmationTitle>
          {t('security.culture.send.survey.scheduled.heading')}
        </ConfirmationTitle>
        <ConfirmationDescription>
          {t('security.culture.send.survey.scheduled.description')}
        </ConfirmationDescription>
      </ConfirmationContent>
      <FlexContainer gap={20} justify="center" align="center" width="auto">
        <AppButton
          label={t('security.culture.send.survey.find.template')}
          onClick={() =>
            window.open(
              SC_COMMUNICATION_TEMPLATE_URL,
              '_blank',
              'noopener,noreferrer',
            )
          }
        />
        <AppButton
          severity="underline"
          label={t('security.culture.send.survey.go.to.dashboard')}
          onClick={onGoToDashboard}
        />
      </FlexContainer>
    </ConfirmationBox>
  );
};
